import React from "react";
import "../../styles/Attendance.css";

const Attendance = () => {
  const attendanceData = [
    {
      date: "21 Sep 2026",
      day: "Monday",
      checkIn: "09:15 AM",
      checkOut: "06:10 PM",
      status: "Present",
    },
    {
      date: "19 Sep 2026",
      day: "Saturday",
      checkIn: "09:20 AM",
      checkOut: "06:05 PM",
      status: "Late",
    },
    {
      date: "18 Sep 2026",
      day: "Friday",
      checkIn: "09:05 AM",
      checkOut: "06:00 PM",
      status: "Present",
    },
    {
      date: "17 Sep 2026",
      day: "Thursday",
      checkIn: "-",
      checkOut: "-",
      status: "Absent",
    },
  ];

  return (
    <div className="attendance-container">
      <h2>Attendance</h2>

      <p className="attendance-subtitle">
        View your attendance and working hours.
      </p>

      {/* Summary Cards */}
      <div className="attendance-summary">

        <div className="attendance-card">
          <h4>Present</h4>
          <h2>18</h2>
          <p>Days</p>
        </div>

        <div className="attendance-card">
          <h4>Absent</h4>
          <h2>2</h2>
          <p>Days</p>
        </div>

        <div className="attendance-card">
          <h4>Late</h4>
          <h2>3</h2>
          <p>Days</p>
        </div>

        <div className="attendance-card">
          <h4>Working Days</h4>
          <h2>23</h2>
          <p>Days</p>
        </div>

      </div>

      {/* Attendance Table */}
      <div className="attendance-table-container">
        <h3>Attendance Details</h3>

        <table className="attendance-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Day</th>
              <th>Check In</th>
              <th>Check Out</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {attendanceData.map((attendance, index) => (
              <tr key={index}>
                <td>{attendance.date}</td>
                <td>{attendance.day}</td>
                <td>{attendance.checkIn}</td>
                <td>{attendance.checkOut}</td>

                <td>
                  <span
                    className={`attendance-status ${attendance.status.toLowerCase()}`}
                  >
                    {attendance.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Attendance;